import React from 'react';
import PropTypes from 'prop-types';
import Radium from 'radium';

const Step = Radium(({ number, state, children }) => (
  // style hack - works only with 3 children!
  <div style={[styles.section, { left: `calc(${number - 2} * (100% / 3 / 2))` }]}>
    <div>
      <strong style={styles.numberbox}>
        {state === 'completed' ? <i className="fa fa-check" style={styles.complete} /> : number }
      </strong>
    </div>
    <div style={styles.textbox}>{children}</div>
  </div>
));

Step.propTypes = {
  children: PropTypes.string.isRequired,
  number: PropTypes.number.isRequired,
  state: PropTypes.string
};

Step.defaultProps = {
  state: undefined
};

@Radium
export default class Progress extends React.Component {
  static propTypes = {
    active: PropTypes.number.isRequired
  }

  getStepState(stepNumber) {
    const { active } = this.props;

    if (stepNumber === active) {
      return 'active';
    } else if (stepNumber < active) {
      return 'completed';
    }

    return null;
  }

  render() {
    return (
      <div style={styles.counter}>
        <Step number={1} state={this.getStepState(1)}>
          Výběr kategorie
        </Step>
        <Step number={2} state={this.getStepState(2)}>
          Výběr workshopu
        </Step>
        <Step number={3} state={this.getStepState(3)}>
          Kontaktní údaje
        </Step>
        <br style={{ clear: 'both' }} />
      </div>
    );
  }
}

const styles = {
  counter: {
    display: 'flex',
    justifyContent: 'space-evenly',
    borderTop: '2px solid #5d9f51',
    width: '80%',
    margin: '35px auto 0 auto'
  },
  section: {
    display: 'flex',
    flexDirection: 'column',
    flex: '1 1 0',
    position: 'relative',
    top: -20.5,
    textAlign: 'center',
  },
  numberbox: {
    border: '2px solid #5d9f51',
    borderRadius: '50%',
    fontSize: 26,
    width: 41,
    height: 41,
    display: 'inline-block',
    backgroundColor: '#FFF',
    textAlign: 'center'
  },
  complete: {
    color: '#5d9f51'
  }
};



// WEBPACK FOOTER //
// ./src/browser/Feature/order/progress.jsx